export default __webpack_public_path__ + "static/media/edit-notification.e6d21967.svg";